import { baseApi } from '@shared/api/baseApi'

export interface LinkTelegramGenerateResponse {
  link: string
  expires_at: string
}

export interface LinkTelegramConfirmResponse {
  user_id: number
  merged: boolean
  already_linked: boolean
  email: string | null
  merge_details: Record<string, unknown> | null
}

export const generateLinkTelegram = async (): Promise<LinkTelegramGenerateResponse> => {
  const { data } = await baseApi.post<LinkTelegramGenerateResponse>('/api/user/link-telegram')
  return data
}

export const confirmLinkTelegram = async (token: string): Promise<LinkTelegramConfirmResponse> => {
  const { data } = await baseApi.post<LinkTelegramConfirmResponse>(
    '/api/user/link-telegram/confirm',
    { token }
  )
  return data
}
